export const CLOCK_IN_FEATURE = 'timetracking.clock-in';
export const CLOCK_OUT_FEATURE = 'timetracking.clock-out';

export const TIMETRACKING_FEATURES = {
  moduleKey: 'timetracking',
  features: [
    CLOCK_IN_FEATURE,
    CLOCK_OUT_FEATURE,
    'timetracking.reports',
    'timetracking.balances',
    'timetracking.absenceApproval',
    'timetracking.settings',
  ] as const,
  featureMeta: {
    [CLOCK_IN_FEATURE]: {
      name: 'Clock in',
      translations: { name: { de: 'Einstempeln', en: 'Clock in', fr: 'Pointer', it: 'Registrazione ingresso' } },
    },
    [CLOCK_OUT_FEATURE]: {
      name: 'Clock out',
      translations: { name: { de: 'Ausstempeln', en: 'Clock out', fr: 'Pointer la sortie', it: 'Registrazione uscita' } },
    },
    'timetracking.reports': {
      name: 'Time tracking reports',
      translations: {
        name: {
          de: 'Zeiterfassungsberichte',
          en: 'Time tracking reports',
          fr: 'Rapports de suivi du temps',
          it: 'Report del rilevamento del tempo',
        },
      },
    },
    'timetracking.balances': {
      name: 'Time balances',
      translations: { name: { de: 'Zeitguthaben', en: 'Time balances', fr: 'Soldes horaires', it: 'Saldi orari' } },
    },
    'timetracking.absenceApproval': {
      name: 'Absence approval',
      translations: {
        name: {
          de: 'Absenzfreigabe',
          en: 'Absence approval',
          fr: 'Approbation des absences',
          it: 'Approvazione delle assenze',
        },
      },
    },
    'timetracking.settings': {
      name: 'Time tracking settings',
      translations: {
        name: {
          de: 'Zeiterfassungseinstellungen',
          en: 'Time tracking settings',
          fr: 'Paramètres du suivi du temps',
          it: 'Impostazioni del rilevamento del tempo',
        },
      },
    },
  },
} as const;
